export enum ParkingLotInputType {
    None = 0,
    Camera = 1,
    LinkBaseIn = 2
  }
  